import { useStaticQuery, graphql } from "gatsby"

import { sanitizeForDisplay } from "../utils/general"

const query = graphql`
  query FaqQuery {
    allContentfulModule(filter: { moduleUid: { regex: "/faq/" } }) {
      edges {
        node {
          moduleUid
          title
          image
          ref
          moduleReferences {
            ... on ContentfulFrequentlyAskedQuestions {
              question
              answer {
                answer
              }
            }
          }
        }
      }
    }
  }
`

export const useContentfulFaq = () => {
  const data = useStaticQuery(query)

  const questions = {}

  data.allContentfulModule.edges.forEach(({ node }) => {
    const key = node?.moduleUid?.replace("faq-", "#")
    questions[key] = {
      title: node.title,
      productImage: node.image,
      notes: node.ref,
      accordions: node.moduleReferences.map((ref) => ({
        title: sanitizeForDisplay(ref.question),
        content: sanitizeForDisplay(ref.answer?.answer),
      })),
    }
  })
  return questions
}
